import React from "react";
import { LocalKeys, useTranslation } from "utilities/i18n";
import { DefaultModalForm, useModalDispatch } from "./Modal";
import { CancelButton } from "elements";

interface DeleteModalProps {
  onDelete: () => void;
  action?: LocalKeys;
  title?: string;
  entity?: string;
  children?: React.ReactNode;
  confirmationString?: React.ReactNode;
  disabled?: boolean;
  name: string;
}

const DeleteModal: React.FC<DeleteModalProps> = props => {
  const {
    onDelete,
    children,
    action,
    entity,
    confirmationString,
    disabled,
    name,
    title
  } = props;
  const { t } = useTranslation();
  const dispatchEvent = useModalDispatch();
  const maxTitleLength = 30;

  const actionText = t(action || "DELETE");
  return (
    <DefaultModalForm
      title={
        title ??
        `
        ${actionText}
        ${
          entity && entity.length < maxTitleLength
            ? entity
            : entity?.substr(0, maxTitleLength) + "..."
        }
      `
      }
      onSubmit={onDelete}
      name={name}
    >
      <div data-testid="delete-modal">
        <div className="small-text" data-testid="confirmation">
          {confirmationString}
        </div>
        {children}
        <div className="btn-container">
          <CancelButton onClick={dispatchEvent} disabled={disabled} />
          <button
            type="submit"
            className="btn btn-primary"
            data-testid="delete"
            disabled={disabled}
          >
            {actionText}
          </button>
        </div>
      </div>
    </DefaultModalForm>
  );
};

export default DeleteModal;
